import { instance } from '@/api/index';

/** 로그인 수행
 * @param userData
 */
function loginUser(userData) {
  return instance.post('/api/esm/default/nss_login_check', userData);
}

/** 로그아웃 수행
 */
function logoutUser() {
  return instance.post('/api/esm/default/nss_logout');
}

/** 패스워드 변경 수행
 * @param changeUserdata
 */
function newPasswordUser(changeUserdata) {
  return instance.post('/api/esm/default/nss_changepassword', changeUserdata);
}

/** 로그인 사용자 정보
 * @param userData
 */
function fetchLoginUserInfo(userData) {
  return instance.post('/api/administrator/getUserSimpleInfo', userData);
}

/** 로그인 사용자 정보 수정
 * @param userData
 */
function fetchUserInfoChange(userData) {
  return instance.post('/api/administrator/setUserSimpleInfo', userData);
}

/** sesstion timeout check
 * @param userData
 */
function getNssSessionCheck(userData) {
  return instance.post('/api/esm/default/nss_session_check', userData);
}

export {
  loginUser,
  logoutUser,
  newPasswordUser,
  fetchLoginUserInfo,
  fetchUserInfoChange,
  getNssSessionCheck,
};
